import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// ---- Stories ----
export const listStories = () => api.get("/stories").then((r) => r.data);
export const getStory = (id) => api.get(`/stories/${id}`).then((r) => r.data);
export const createStory = (payload) => api.post("/stories", payload).then((r) => r.data);
export const deleteStory = (id) => api.delete(`/stories/${id}`).then((r) => r.data);

// ---- Characters (Stage 2 — Character Lock) ----
export const listCharacters = (storyId) => api.get(`/stories/${storyId}/characters`).then((r) => r.data);
export const createCharacter = (storyId, name, isMain = false) =>
  api.post(`/stories/${storyId}/characters`, { name, is_main: isMain }).then((r) => r.data);
export const deleteCharacter = (characterId) => api.delete(`/characters/${characterId}`).then((r) => r.data);
export const remapCharacter = (characterId, newName) => api.post(`/characters/${characterId}/remap`, { new_name: newName }).then((r) => r.data);
export const uploadBaseImage = (characterId, file) => {
  const form = new FormData();
  form.append("file", file);
  return api
    .post(`/characters/${characterId}/base-image`, form, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};
export const addOutfit = (characterId, outfit_name, descriptor) =>
  api.post(`/characters/${characterId}/outfits`, { outfit_name, descriptor }).then((r) => r.data);
export const deleteOutfit = (characterId, outfitId) =>
  api.delete(`/characters/${characterId}/outfits/${outfitId}`).then((r) => r.data);
export const uploadOutfitImage = (characterId, outfitId, file) => {
  const form = new FormData();
  form.append("file", file);
  return api
    .post(`/characters/${characterId}/outfits/${outfitId}/images`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const setHeroImage = (characterId, outfitId, imagePath) =>
  api.patch(`/characters/${characterId}/outfits/${outfitId}/hero-image`, { image_path: imagePath }).then((r) => r.data);
export const setVisualTag = (characterId, visualTag) =>
  api.patch(`/characters/${characterId}/visual-tag`, { visual_tag: visualTag }).then((r) => r.data);
export const fileUrl = (path) => `${API}/files/${path}`;

// ---- Stage 1 — Manifest ----
export const generateManifest = (storyId) => api.post(`/stories/${storyId}/generate-manifest`).then((r) => r.data);
export const getManifest = (storyId) => api.get(`/stories/${storyId}/manifest`).then((r) => r.data);
export const updateShot = (shotId, payload) => api.patch(`/shots/${shotId}`, payload).then((r) => r.data);
export const deleteShot = (shotId) => api.delete(`/shots/${shotId}`).then((r) => r.data);
export const moveShot = (shotId, direction) => api.post(`/shots/${shotId}/move`, { direction }).then((r) => r.data);
export const approveManifest = (storyId) => api.post(`/stories/${storyId}/approve-manifest`).then((r) => r.data);
export const unlockManifest = (storyId, note) => api.post(`/stories/${storyId}/unlock-manifest`, { note }).then((r) => r.data);
export const getManifestEvents = (storyId) => api.get(`/stories/${storyId}/manifest-events`).then((r) => r.data);
export const getLatestNotification = (storyId) => api.get(`/stories/${storyId}/notifications/latest`).then((r) => r.data);

// ---- Stage 3/4 — Batch generation + Warden QC ----
export const runBatch = (storyId, shotIds) => api.post(`/stories/${storyId}/batch/run`, { shot_ids: shotIds }).then((r) => r.data);
export const getShotAttempts = (shotId) => api.get(`/shots/${shotId}/attempts`).then((r) => r.data);
export const getBatchSummary = (storyId) => api.get(`/stories/${storyId}/batch/summary`).then((r) => r.data);
export const setBudget = (storyId, amount) => api.patch(`/stories/${storyId}/budget`, { xai_credit_budget: amount }).then((r) => r.data);
export const extendClip = (shotId, prompt, duration) => api.post(`/shots/${shotId}/extend-clip`, { prompt, duration }).then((r) => r.data);
export const generateVideoFromStill = (shotId, prompt) => api.post(`/shots/${shotId}/generate-video`, { prompt }).then((r) => r.data);

// ---- Continuity Chain — Locations, Props, Promote-to-Lock, First-Appearance Gate ----
export const listLocations = (storyId) => api.get(`/stories/${storyId}/locations`).then((r) => r.data);
export const createLocation = (storyId, name, descriptor = "") => api.post(`/stories/${storyId}/locations`, { name, descriptor }).then((r) => r.data);
export const deleteLocation = (locationId) => api.delete(`/locations/${locationId}`).then((r) => r.data);
export const uploadLocationImage = (locationId, file) => {
  const form = new FormData();
  form.append("file", file);
  return api.post(`/locations/${locationId}/images`, form, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const setLocationHeroImage = (locationId, imagePath) =>
  api.patch(`/locations/${locationId}/hero-image`, { image_path: imagePath }).then((r) => r.data);

export const listProps = (storyId) => api.get(`/stories/${storyId}/props`).then((r) => r.data);
export const createProp = (storyId, name, descriptor = "") => api.post(`/stories/${storyId}/props`, { name, descriptor }).then((r) => r.data);
export const deleteProp = (propId) => api.delete(`/props/${propId}`).then((r) => r.data);
export const uploadPropImage = (propId, file) => {
  const form = new FormData();
  form.append("file", file);
  return api.post(`/props/${propId}/images`, form, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const setPropHeroImage = (propId, imagePath) => api.patch(`/props/${propId}/hero-image`, { image_path: imagePath }).then((r) => r.data);

export const promoteToLock = (attemptId, payload) => api.post(`/shot-attempts/${attemptId}/promote`, payload).then((r) => r.data);
export const approveFirstAppearance = (shotId) => api.post(`/shots/${shotId}/approve-first-appearance`).then((r) => r.data);
export const rejectFirstAppearance = (shotId) => api.post(`/shots/${shotId}/reject-first-appearance`).then((r) => r.data);
export const setRefPriority = (shotId, priorityOrder) => api.post(`/shots/${shotId}/set-ref-priority`, { priority_order: priorityOrder }).then((r) => r.data);

// ---- Manual Review escape valve (post-3-failure) ----
export const uploadManualReference = (shotId, file) => {
  const form = new FormData();
  form.append("file", file);
  return api.post(`/shots/${shotId}/manual-references`, form, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const deleteManualReference = (shotId, imagePath) =>
  api.delete(`/shots/${shotId}/manual-references`, { params: { image_path: imagePath } }).then((r) => r.data);
export const manualRetryShot = (shotId) => api.post(`/shots/${shotId}/manual-retry`).then((r) => r.data);
export const manualFinalizeShot = (shotId, imagePath) => api.post(`/shots/${shotId}/manual-finalize`, { image_path: imagePath }).then((r) => r.data);
export const approveAttempt = (shotId, attemptId) => api.post(`/shots/${shotId}/attempts/${attemptId}/approve`).then((r) => r.data);

// ---- Phase 4 — DaVinci Resolve Draft Export ----
export const getExportPreview = (storyId) => api.get(`/stories/${storyId}/export/preview`).then((r) => r.data);
export const updateShotScreenDuration = (shotId, seconds) =>
  api.patch(`/shots/${shotId}/screen-duration`, { screen_duration_seconds: seconds }).then((r) => r.data);
export const buildExportPackage = (storyId) =>
  api.post(`/stories/${storyId}/export/build`, {}, { responseType: "blob" }).then((r) => r.data);
